import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import axios from 'axios';
import {toast} from 'react-toastify';
import {setLoader} from './reducer';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import routes from '../../utils/routes';
import {
  removeCurrentFboAll,
  removeFCMToken,
  removeUserToken,
} from '../../utils/tokenHandler';
const initialState = {
  user: null,
  isLoading: false,
  error: null,
};

const loginSlice = createSlice({
  name: 'authorization',
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getUser.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
      })
      .addCase(getUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const {setUser} = loginSlice.actions;
export default loginSlice.reducer;

export const getUser = createAsyncThunk(
  'authorization/getUser',
  async (userId, {rejectWithValue}) => {
    try {
      const deviceId = localStorage.getItem('inspection_deviceId');
      const token = localStorage.getItem('ndx_user_token');
      const language = localStorage.getItem('language');
      let config = {
        headers: {
          Authorization: 'Bearer ' + token,
          AppVersion: '1.0.0',
          AppType: 'web',
          DeviceType: 'web',
          DeviceId: deviceId,
          'accept-language': language,
        },
      };
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}user`,
        config,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch user data',
      );
    }
  },
);

export const logoutUser = createAsyncThunk(
  'authorization/logout',
  async (userId, {rejectWithValue}) => {
    try {
      const deviceId = localStorage.getItem('inspection_deviceId');
      const token = localStorage.getItem('ndx_user_token');
      const language = localStorage.getItem('language');
      let config = {
        headers: {
          Authorization: 'Bearer ' + token,
          AppVersion: '1.0.0',
          AppType: 'web',
          DeviceType: 'web',
          DeviceId: deviceId,
          'accept-language': language,
        },
      };
      const {data, status} = await axios.post(
        `${import.meta.env.VITE_API_URL}auth/logout`,
        {},
        config,
      );

      if (status === 200) {
        removeFCMToken();
        removeUserToken();
        removeCurrentFboAll();
        localStorage.removeItem('user-type');
        localStorage.removeItem('showedMobilePopup');
      }

      if (status === 200 && data.message) {
        toast.success(data.message);
      }

      if (data?.logout_link) {
        window.location.href = data?.logout_link;
      } else {
        window.location.href = routes.public.login;
      }

      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch user data',
      );
    }
  },
);
